import { gdeltApi } from './gdelt';
export * from './gdelt';

export const gdeltEndpoints = { ...gdeltApi.endpoints };
